import React, { useEffect, useState } from "react";
import { useParams, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import * as QueryString from "query-string";
import {
  dealjacketActions,
  alertActions,
  pagetypeActions,
  orgActions,
} from "../../actions";
import { SearchInput } from "./SearchInput";
import { SearchResults } from "./SearchResults";
import { history } from "../../helpers";

function SearchPage(props) {
  const {
    authentication,
    dealjackets,
    getOrgList,
    org,
    getPagetypeList,
    location,
    search,
    clearSearch
  } = props;
  const auth_user_id = authentication?.user?.id;
  const search_results = dealjackets?.searchResults;
  const result_content = search_results?.results;
  const org_id = org.current_org_id;
  const old_query_string =  dealjackets?.queryString;

  if (!location?.search && old_query_string) {
    history.push("/org/" + org_id + "/dealjackets?" + old_query_string);
  }

  const params = QueryString.parse(location?.search);

  const queryType = params.q;
  const queryTerm = params.t;
  const queryLimit = params.l;
  const queryOffset = params.o;
  const doctype = params.d;



  const { id } = useParams();

  const [searchRequest, setSearchRequest] = useState({});

  useEffect(() => {
    getPagetypeList(id);
    getOrgList(auth_user_id);
  }, [id, auth_user_id, getOrgList, getPagetypeList]);

  useEffect(() => {
      if (queryTerm) {
        const req = {
          org_id: Number(org_id),
          term: queryTerm,
          type: queryType,
          limit: Number(queryLimit),
          offset: queryOffset?Number(queryOffset):0,
          doctype: doctype
        };
        setSearchRequest(req);
        search(req);
      };
  }, [org_id, queryType, queryTerm, queryLimit, queryOffset, doctype]);

  const getCurrentOrgName = (org_id) => {
    return org?.list?.filter((org) => org.org_id === Number(org_id))[0]
      .display_name;
  };

  return (
    <div className="contentContainer">
      {org.list && (
        <div className="searchMain">
          <div className="contentContainerLeftNav">
            <div className="rightContent">
              <h3>{getCurrentOrgName(id)}</h3>
              <SearchInput org_id={id} />
              {search_results && <SearchResults searchRequest={searchRequest} params={params} org_id={org_id}/>}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function mapStateToProps(state) {
  const { dealjackets, authentication, org } = state;
  return {
    dealjackets,
    authentication,
    org,
  };
}

const actionCreators = {
  getOrgList: orgActions.getList,
  getDealjacketList: dealjacketActions.getList,
  alertPrompt: alertActions.prompt,
  getPagetypeList: pagetypeActions.getList,
  search: dealjacketActions.search,
  clearSearch: dealjacketActions.clearSearch
};

const connectedSearchPage = withRouter(
  connect(mapStateToProps, actionCreators)(SearchPage)
);
export { connectedSearchPage as SearchPage };
